// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__163BQ","selected":"Chip_selected__1J_-Y"};